import { IconButton, useBoolean } from '@chakra-ui/react';
import { ReactComponent as DeleteIcon } from 'assets/icons/delete.svg';
import { useTranslation } from 'react-i18next';

import { GenerationDiscardModal } from './GenerationDiscardModal';

interface GenerationDiscardTriggerProps {
  onDiscard: () => void;
  fromParent: string;
}

export const GenerationDiscardTrigger = ({ onDiscard, fromParent }: GenerationDiscardTriggerProps) => {
  const { t } = useTranslation('editor_widget_toolbar', {
    useSuspense: false,
    keyPrefix: 'textToolbar.improveText.discardGeneration',
  });
  const [isOpen, setIsOpen] = useBoolean(false);

  const ariaLabel = t('ariaLabel');

  return (
    <>
      <IconButton variant='ghost' aria-label={ariaLabel} icon={<DeleteIcon />} size='xs' onClick={setIsOpen.on} />
      <GenerationDiscardModal isOpen={isOpen} onClose={setIsOpen.off} onDiscard={onDiscard} fromParent={fromParent} />
    </>
  );
};
